// Minimal dotted-numeric version comparison for changelog diffing. Not a full
// semver implementation: pre-release/build metadata is ignored (non-numeric parts
// parse as 0), which is all the changelog needs — versions come from
// package.json / the VERSION env and are plain `major.minor.patch`.
//
// `export function` (not `export const … = (a, b) =>`): this dir auto-imports, and
// the export scanner comma-splits multi-param arrow params into phantom exports
// that fail at ESM link time (see .claude/BUILD_PROCESS.md).

function parseVersion(version: string): number[] {
	return String(version ?? '')
		.split('.')
		.map((part) => {
			const n = Number.parseInt(part, 10);
			return Number.isNaN(n) ? 0 : n;
		});
}

// Returns <0 when a < b, 0 when equal, >0 when a > b. Missing trailing segments
// are treated as 0, so "1.1" and "1.1.0" compare equal.
export function compareVersions(a: string, b: string): number {
	const pa = parseVersion(a);
	const pb = parseVersion(b);
	const len = Math.max(pa.length, pb.length);
	for (let i = 0; i < len; i++) {
		const na = pa[i] ?? 0;
		const nb = pb[i] ?? 0;
		if (na !== nb) return na < nb ? -1 : 1;
	}
	return 0;
}
